import { isEmpty, isNil } from 'ramda'

/**
 * converts date from any valid format into an ISO string ex. '2020-05-18T22:25:36.767Z'
 * @param {string} date datetime string or JS date time object
 * @returns {string} date converted to ISO format
 */
export const convertToISOString = date => {
  if (isNil(date) || isEmpty(date)) return ''
  return new Date(date).toISOString()
}
